import React from 'react';
import { WayfindingMessage } from '../../../domain/richMessage.interface';

interface WayfindingCardProps {
  data: WayfindingMessage;
}

export const WayfindingCard: React.FC<WayfindingCardProps> = ({ data }) => (
  <div className="bg-white rounded-2xl border border-black/[0.08] shadow-sm overflow-hidden">
    <div className="bg-navy px-4 py-3">
      <p className="text-white font-bold text-xs uppercase tracking-widest">
        {data.title} · WAYFINDING
      </p>
    </div>
    <div className="divide-y divide-grey-91">
      {data.rows.map((row, i) => (
        <div key={i} className="flex items-center justify-between px-4 py-3">
          <span className="text-navy-64 text-sm">{row.label}</span>
          <span className="text-navy font-bold text-sm text-right">{row.value}</span>
        </div>
      ))}
    </div>
    {data.instructions && (
      <div className="px-4 py-3 border-t border-grey-91">
        <p className="text-navy text-sm leading-relaxed">{data.instructions}</p>
      </div>
    )}
  </div>
);
